<template>
  <div class="cablePurchaseDetail">
    <template>
      <div class="sousuo">
        <div class="sousuo-nr">
          <div class="vm-search">
            <vm-search label="预测月份">
              <div class="block">
                <el-date-picker
                    v-model="filter.totalDate"
                    value-format="yyyy-MM"
                    type="date"
                    style="width: 190px"
                    placeholder="选择开始日期"/>
              </div>
            </vm-search>
            <vm-search label="统计类型">
              <el-select v-model="filter.totalType" placeholder="请选择统计类型">
                <el-option label="销售区域" :value="1"/>
                <el-option label="产品类型" :value="2"/>
                <el-option label="销售员" :value="3"/>
              </el-select>
            </vm-search>
            <vm-search label="客户名称">
              <el-input v-model.trim="filter.customerName" clearable/>
            </vm-search>
            <vm-search label="销售员">
              <el-input v-model.trim="filter.salesManName" clearable/>
            </vm-search>
          </div>
        </div>
      </div>
      <div class="ad-search-btn" style="text-align: right;margin: 1% 0;">
        <el-button
            :loading="loading"
            type="primary"
            size="mini"
            style="height: 26px;padding: 0 10px"
            @click="handleSearchClick">
          查询
        </el-button>
        <el-button
            plain
            type="primary"
            size="mini"
            style="height: 26px;padding: 0 10px"
            @click="handleClearClick">
          重置
        </el-button>
      </div>
    </template>
    <el-table
        v-if="filter.totalType===1"
        v-loading="loading"
        :data="tableData"
        height="60vh"
        style="width: 100%">
      <el-table-column fixed="left" type="expand">
        <template slot-scope="props">
          <el-form>
            <div class="vm-separate">
              <el-table :data="props.row.customers" border style="width: 100%;margin-right: 5px">
                <el-table-column align="center" label="客户名称" prop="customerName"/>
              </el-table>
              <el-table :data="props.row.salesForecastTotalDetailVOS" border style="width: 100%;margin: 0 auto">
                <el-table-column align="center" label="物料类型" prop="materialType"/>
                <el-table-column align="center" label="后半月(1-15)" prop="firstHalf"/>
                <el-table-column align="center" label="后半月(15-30)" prop="secondHalf"/>
                <el-table-column align="center" label="后一月" prop="nextMonth"/>
                <el-table-column align="center" label="后二月" prop="nextFebruary"/>
              </el-table>
            </div>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="区域名称" prop="departmentName"/>
    </el-table>
    <el-table
        v-else-if="filter.totalType===2"
        v-loading="loading"
        :data="tableData"
        height="60vh"
        style="width: 100%">
      <el-table-column fixed="left" type="expand">
        <template slot-scope="props">
          <el-form>
            <div class="vm-separate">
              <el-table :data="props.row.customers" border style="width: 100%;margin-right: 5px">
                <el-table-column align="center" label="客户名称" prop="customerName"/>
              </el-table>
              <el-table :data="props.row.salesForecastTotalDetailVOS" border style="width: 100%;margin: 0 auto">
                <el-table-column align="center" label="物料类型" prop="materialType"/>
                <el-table-column align="center" label="后半月(1-15)" prop="firstHalf"/>
                <el-table-column align="center" label="后半月(15-30)" prop="secondHalf"/>
                <el-table-column align="center" label="后一月" prop="nextMonth"/>
                <el-table-column align="center" label="后二月" prop="nextFebruary"/>
              </el-table>
            </div>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="产品类型" prop="materialType"/>
    </el-table>
    <el-table
        v-else-if="filter.totalType===3"
        v-loading="loading"
        :data="tableData"
        height="60vh"
        style="width: 100%">
      <el-table-column fixed="left" type="expand">
        <template slot-scope="props">
          <el-form>
            <el-table :data="props.row.salesForecastTotalDetailVOS" style="width: 100%;margin: 0 auto">
              <el-table-column align="center" label="物料类型" prop="materialType"/>
              <el-table-column align="center" label="后半月(1-15)" prop="firstHalf"/>
              <el-table-column align="center" label="后半月(15-30)" prop="secondHalf"/>
              <el-table-column align="center" label="后一月" prop="nextMonth"/>
              <el-table-column align="center" label="后二月" prop="nextFebruary"/>
            </el-table>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="销售员" prop="salesman"/>
    </el-table>
  </div>
</template>

<script>
  import constants from "../../../util/constants";
  import constant from "../../../util/constant";
  import VmSearch from "../../../components/VmSearch";

  export default {
    name: "",
    components: {VmSearch},
    data() {
      return {
        constant,
        constants,
        loading: false,
        currentPage: 1,
        pageSize: 10,
        total: 0,
        exportLoading: false,
        submitLoading: false,
        submitLoading1: false,
        submitLoading2: false,
        submitLoading3: false,
        dialogVisible: false,
        adSearchShow: false,
        tableData: [],
        filter: {
          customerName: "",
          salesManName: "",
          totalDate: "",
          totalType: 1,
        },
      };
    },
    mounted() {
      this.initTime();
    },
    methods: {
      initTime() {
        // this.filter.totalDate = this.getFormatDate(new Date());
        this.getList(1);
      },
      // 获取当前时间
      getFormatDate(date) {
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return date.getFullYear() + "-" + month + "-" + strDate;
      },
      getList() {
        this.loading = true;
        let url = "";
        if (this.filter.totalType === 1) {
          url = "salesForecastTotals/getListByArea";
        } else if (this.filter.totalType === 2) {
          url = "salesForecastTotals/getListByMaterialType";
        } else if (this.filter.totalType === 3) {
          url = "salesForecastTotals/getListBySalesman";
        } else {
          return this.$message.error("请选择统计类型");
        }
        this.$http.get("basic", url, this.filter).then(res => {
          this.loading = false;
          this.tableData = res;
        }).catch(() => {
          this.loading = false;
          this.$message.error("获取失败");
        });
      },
      handleSearch() {
        this.getList(1);
      },
      handleClearClick() {
        this.filter.customerName = "";
        this.filter.salesManName = "";
        this.filter.totalDate = "";
        this.filter.totalType = "";
        this.$nextTick(() => {
          this.getList(1);
        });
      },
      handleSearchClick() {
        this.getList(1);
      },
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", "cablePurchaseOrderDetail/exportStocking", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss">
.cablePurchaseDetail {
  position: relative;

  .el-pagination {
    text-align: right;
  }

  .toolbar-btn {
    margin-bottom: 13px;
    display: flex;
    flex-direction: row;
    -webkit-align-content: center;
    align-items: center;
  }

  .sousuo {
    width: 100%;
    background: #f4f7fa;
    margin-bottom: 1%;
    border: 1px solid #EBEEF5;

    .sousuo-nr {
      padding: 8px 133px 8px 10px;
    }

    .ad-search-btn {
      text-align: right;
      margin: 1% 2%;
    }
  }
}
</style>
